import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SureFlowAutoSelectInput} from '../../model/sure-flow-auto-select-input';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';


@Component({
    selector: 'app-auto-select-sure-flow-units-dialog',
    templateUrl: './auto-select-sure-flow-units-dialog.component.html',
    styleUrls: ['./auto-select-sure-flow-units-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatRadioGroup, FormsModule, MatRadioButton, MatButton]
})
export class AutoSelectSureFlowUnitsDialogComponent {
  private dialogRef = inject<MatDialogRef<AutoSelectSureFlowUnitsDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  readonly input: SureFlowAutoSelectInput;
  readonly selectedUnitIds: number[];
  readonly allUnitIds: number[];
  isSelectedOnly: boolean = false;

  constructor() {
    const data = this.data;

    this.input = new SureFlowAutoSelectInput();
    this.input.cooling = data.isCooling;
    this.input.loopDetail = data.loopDetail;
    this.input.sensibleTarget = data.isCooling;
    this.selectedUnitIds = data.selectedUnitIds || [];
    this.allUnitIds = data.allUnitIds;
    if ((this.selectedUnitIds?.length || 0) === 0) {
      this.input.selectedUnitIds = this.allUnitIds;
    } else {
      this.input.selectedUnitIds = this.selectedUnitIds;
      this.isSelectedOnly = true;
    }
  }

  behaviorChanged(): void {
    if (this.isSelectedOnly) {
      this.input.selectedUnitIds = this.selectedUnitIds;
    } else {
      this.input.selectedUnitIds = this.allUnitIds;
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.input);
  }

}
